export const videoBlock = `
_type == 'videoBlock' => {
  "video_id": video_id[_key == $lang][0].value,
  "video_mobile_id": video_mobile_id[_key == $lang][0].value,
  "default_video_id": video_id[_key == "fr"][0].value,
  "default_video_mobile_id": video_mobile_id[_key == "fr"][0].value,
}
`
